import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { FourStars } from "./FourStars";
import { Mail, Phone, MapPin, Facebook, Twitter, Youtube, Instagram } from "lucide-react";

export const Footer = () => (
  <footer className="bg-[#0A0F1A] text-white mt-24" data-testid="footer">
    {/* Top devise band */}
    <div className="bg-gradient-to-r from-[#0052CC] via-[#D4AF37] to-[#CE1126] h-1" />
    <div className="max-w-7xl mx-auto px-4 md:px-8 pt-16 pb-10 grid grid-cols-1 md:grid-cols-4 gap-10">
      <div className="md:col-span-1 space-y-4">
        <Logo dark size={64} />
        <p className="text-sm text-white/65 leading-relaxed">
          Mouvement citoyen et patriotique au service du peuple congolais et du Président de la République Démocratique du Congo.
        </p>
        <div className="text-[11px] uppercase tracking-[0.32em] font-semibold text-[#D4AF37]">
          ★ Unité — Progrès — Travail ★
        </div>
        <FourStars size={14} />
      </div>

      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Le Mouvement</div>
        <ul className="space-y-2.5 text-sm text-white/75">
          <li><Link to="/actualites" className="hover:text-[#D4AF37]">Actualités</Link></li>
          <li><Link to="/actions" className="hover:text-[#D4AF37]">Actions du Président</Link></li>
          <li><Link to="/soutien-est" className="hover:text-[#D4AF37]">Soutien à l'Est</Link></li>
          <li><Link to="/solidarite" className="hover:text-[#D4AF37]">Solidarité</Link></li>
          <li><Link to="/sondages" className="hover:text-[#D4AF37]">Sondages & Élections</Link></li>
        </ul>
      </div>

      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Espace Membre</div>
        <ul className="space-y-2.5 text-sm text-white/75">
          <li><Link to="/register" className="hover:text-[#D4AF37]">Devenir membre</Link></li>
          <li><Link to="/login" className="hover:text-[#D4AF37]">Connexion</Link></li>
          <li><Link to="/dashboard" className="hover:text-[#D4AF37]">Mon espace</Link></li>
          <li><Link to="/dons" className="hover:text-[#D4AF37]">Dons & Cotisations</Link></li>
        </ul>
      </div>

      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Contact</div>
        <ul className="space-y-2.5 text-sm text-white/75">
          <li className="flex items-start gap-2"><MapPin size={15} className="mt-0.5 text-[#D4AF37]" /> Kinshasa, République Démocratique du Congo</li>
          <li className="flex items-center gap-2"><Mail size={15} className="text-[#D4AF37]" /> contact@afb-rdc.cd</li>
          <li className="flex items-center gap-2"><Phone size={15} className="text-[#D4AF37]" /> +243 000 000 000</li>
        </ul>
        <div className="flex items-center gap-3 mt-5">
          {[Facebook, Twitter, Youtube, Instagram].map((Icon, i) => (
            <a key={i} href="#" className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors" data-testid={`footer-social-${i}`}>
              <Icon size={15} />
            </a>
          ))}
        </div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/55">
        <div className="text-center md:text-left">© {new Date().getFullYear()} LES AMIS DE FATSHI BÉTON (A.F.B.) — Tous droits réservés.</div>
        <div className="flex items-center gap-4 flex-wrap justify-center">
          <a href="#" className="hover:text-[#D4AF37]">Mentions légales</a>
          <a href="#" className="hover:text-[#D4AF37]">Confidentialité</a>
          <a href="#" className="hover:text-[#D4AF37]">CGU</a>
          <span className="hidden md:inline text-white/20">·</span>
          <a
            href="https://glotechdigital.fr/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-credit-glotech"
            className="inline-flex items-center gap-1.5 text-white/55 hover:text-[#D4AF37] transition-colors"
          >
            Créé par <span className="font-semibold text-white/80 hover:text-[#D4AF37]">Glotech Digital</span>
          </a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
